import { FC } from "react";

import { AttentionBanner, Icon } from "../../common";

type Props = {
  show: boolean;
  setShow: (show: boolean) => void;
};

export const AddBankDetailsBanner: FC<Props> = ({ show, setShow }) => {
  return (
    <div className="w-[340px] h-[244px]">
      <AttentionBanner
        heading={
          <div className="flex items-center gap-4">
            <Icon icon="Wallet" size={24} />
            Add bank details
          </div>
        }
        action={{
          label: "Add INR Bank Account",
          onClick: () => setShow(true),
        }}
      >
        To get transfers add Indian bank details
      </AttentionBanner>
    </div>
  );
};
